import { EmeraldIcon } from "@emerald-react/icon";
import React from "react";

export type Props = {
  surveyContact: {
    contactId: string;
    name: string;
    title?: string;
    licenseNo?: string;
    email: string;
    phoneNumber?: string;
    order: number;
  };
};

const InteractiveSurveyContactPreview: React.FC<Props> = ({
  surveyContact,
}) => {
  return (
    <>
      {surveyContact && (
        <div className="grid grid-rows-[auto_1fr] min-h-[85px] gap-y-1 pt-2 pr-1.5 pb-1.5 pl-2.5">
          {/* Name and Title Section */}
          {(surveyContact.name || surveyContact.title) && (
            <div className="grid gap-y-1 px-1">
              {surveyContact.name && (
                <div>
                  <h3 className="contact-title">{surveyContact.name}</h3>
                </div>
              )}
              {surveyContact.title && (
                <div>
                  <p className="fancy text-cbre-green text-ellipsis line-clamp-3 m-0 text-[0.8rem] font-light">
                    {surveyContact.title}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* Contact Info Section */}
          <div className="grid gap-y-1 px-1 content-start">
            {/* License */}
            {surveyContact.licenseNo && (
              <div className="grid grid-cols-[auto_1fr] gap-2 items-start">
                <span className="text-cbre-green font-thin leading-normal text-xs font-body">
                  {surveyContact.licenseNo}
                </span>
              </div>
            )}

            {/* Phone Number */}
            {surveyContact.phoneNumber && (
              <div className="grid grid-cols-[auto_1fr] gap-2 items-start">
                <EmeraldIcon
                  icon="phone"
                  className="text-cbre-green text-xs! mt-0.5"
                />
                <span className="text-cbre-green font-thin leading-normal text-xs font-body">
                  {surveyContact.phoneNumber}
                </span>
              </div>
            )}

            {/* Email */}
            {surveyContact.email && (
              <div className="grid grid-cols-[auto_1fr] gap-2 items-start min-h-[17px]">
                <EmeraldIcon
                  icon="email"
                  className="text-cbre-green text-xs! mt-0.5"
                />
                <span className="text-cbre-green font-thin leading-normal text-xs font-body">
                  {surveyContact.email}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

InteractiveSurveyContactPreview.displayName = "ContactPreview";
export default InteractiveSurveyContactPreview;
